// extracted by mini-css-extract-plugin
export default {"section":"section__m6Phu","section__content":"section__content__o7S14","section__error":"section__error__fmRPM","hidden":"hidden__a_iT7"};